import React from 'react';

const Logo = ({ className = "w-32", dark = false }) => (
  <img 
    src="https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2UvcG5n/c77bf4f413aeb4c816f6b00b0053e68e.png" 
    alt="EPOQ Learn Logo" 
    className={`object-contain ${dark ? 'brightness-0 invert' : ''} ${className}`}
  />
);

export default Logo;